//商品の価格を3桁でカンマ区切りにし、税込価格を生成する
document.addEventListener('DOMContentLoaded', function() {
  const priceElements = document.querySelectorAll(".js-price-num");

  priceElements.forEach(function(element) {
    // 元の価格を数値に変換
    const originalPrice = parseFloat(element.textContent);
    // カンマ区切りにする
		const formattedPrice = originalPrice.toLocaleString();
		// js-price-num要素に表示
		element.innerHTML = formattedPrice;

    // 税率を設定
    let taxRate = 1.1; // デフォルトは店内の税率10%
    if (document.querySelector('.p-menuTogo')) {
      taxRate = 1.08; // 持ち帰りの場合の税率8%
    }
		// 税込価格を計算(小数点以下は切り捨て)
    const taxPrice = Math.floor(originalPrice * taxRate);

    // 税込価格をカンマ区切りにして表示
    const taxElement = document.querySelector(`.js-price-tax[data-id="${element.dataset.id}"]`);
    if (taxElement) {
      taxElement.innerHTML = taxPrice.toLocaleString();
    }
  });
});
